/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Yup from 'yup';
import { AnyObject } from 'yup/lib/types';

export const yupUniqueTestFunction = (
    field: string,
    errorMessage: string
): Yup.TestFunction<any[] | undefined, AnyObject> =>
    function (array: any[] | undefined) {
        if (!array) {
            return true;
        }
        const uniqueData = Array.from(new Set(array.map(row => row[field])));
        const isUnique = array.length === uniqueData.length;

        if (isUnique) {
            return true;
        }

        const index = array.findIndex((row, i) => row[field] !== uniqueData[i]);
        if (array[index]?.[field] === '' || array[index]?.[field] === null || array[index]?.[field] === undefined) {
            return true;
        }

        return this.createError({
            path: `${this.path}.${index}.${field}`,
            message: errorMessage,
        });
    };
